import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, TextField
} from '@mui/material';

const CancelarModal = ({ open, onClose, idPedido, onActualizar }) => {
  const nuevoEstatus = 'Cancelado';
  const [razon, setRazon] = useState('');

  useEffect(() => {
    if (open) {
      setRazon('');
    }
  }, [open]);

  const handleActualizar = async () => {
    try {
      const payload = {
        IdPedido: idPedido,
        Estatus: nuevoEstatus,
        Comentario: razon
      };

      const response = await fetch(`https://bibliotecadlago.com/php/cancelar_pedido.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        onActualizar();
        onClose();
      } else {
        alert(data.message || 'Error al actualizar el estatus');
      }
    } catch (error) {
      alert('Error de conexión con el servidor');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Cancelar pedido</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="dense" variant="outlined">
          <TextField
            label="Razon"
            placeholder="Escribe la razon..."
            multiline
            rows={3}
            variant="outlined"
            fullWidth
            value={razon}
            onChange={(e) => setRazon(e.target.value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#ff0000', '&:hover': { backgroundColor: '#d10707' } }}
          onClick={handleActualizar}
          disabled={!razon}
        >
          Confirmar cancelación
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelarModal;
